<script>
import Layout from "../../layout/mainLayout";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from 'axios';
/*
 * View User
 */
export default {
  page: {
    title: "View User",
    meta: [
      {
        name: "description",
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      name: "View User",
      title: "View User",
      items: [
        {
          text: "Users",
          href: "/users",
        },
      ],
      form: {
        msisdn: "",
        chatId: "",
        name: "",
      },
      errors: null,
      submitted: false,
      pending: false,
      currrentUser: {},
    };
  },
  methods: {
    async getCurrentUser() {
      let that = this;
      let url = process.env.VUE_APP_BASE_URL+`/api/${appConfig.users.view}`;
      await axios
        .get(url+ this.$route.params.id)
        .then(function (response) {
          that.currrentUser = response.data.result[0];
          that.form = that.currrentUser;
        });
    },
  },
  created() {
    this.pending = true;
    axios.all([this.getCurrentUser()]).finally(() => (this.pending = false));
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card" id="error_area">
          <div class="card-body">
            <FormValidation :errors="errors" />

            <form class="needs-validation">
              <fieldset disabled="true">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group mb-3">
                      <label for="name">Name</label>
                      <input
                        id="name"
                        type="text"
                        v-model="form.name"
                        class="form-control"
                        placeholder="Enter name"
                      />
                    </div>

                    <div class="form-group mb-3">
                      <label for="mobile_phone">Mobile Number</label>
                      <input
                        id="mobile_phone"
                        v-model="form.msisdn"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group mb-3">
                      <label for="email">Email</label>
                      <input
                        id="email"
                        type="text"
                        v-model="form.chatId"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>
                <!-- row -->
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
